var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDusk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.31 68.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f15a29;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.62,38.82c-.7-2.58-1.08-5.29-1.08-8.09C4.54,13.76,18.3,0,35.27,0s30.73,13.76,30.73,30.73c0,2.8-.37,5.51-1.08,8.09"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m51.66,64.26c.64-.34,1.28-.69,1.9-1.07H15.74c.62.38,1.26.73,1.9,1.07h34.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.3,59.05c.35.32.69.64,1.05.95h46.6c.36-.3.7-.63,1.05-.95H10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.98,53.99c.41.54.82,1.08,1.25,1.59h52.84c.43-.51.84-1.05,1.25-1.59H6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.87,49.27c.36.64.73,1.27,1.13,1.89h59.31c.39-.62.76-1.25,1.13-1.89H3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.64,44.75c.32.78.68,1.54,1.05,2.29h63.92c.37-.75.73-1.51,1.05-2.29H1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.74,67.41c2.36.54,7.41.85,9.91.85s7.55-.31,9.91-.85h-19.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,39.91c.25.9.53,1.78.83,2.65h67.64c.31-.87.58-1.75.83-2.65H0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDusk);
export default __webpack_public_path__ + "static/media/Dusk.6bc87cf6af5e002d90807aadf73c04d8.svg";
export { ForwardRef as ReactComponent };